import { FC, useMemo, useCallback } from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment';
import { PdfHtml } from './PdfHtml';

export const OrganizationView: FC<{
  value: any[];
  selectedColor?: string;
}> = ({ value, selectedColor }) => {
  const colors = (color: string) => {
    let color1;
    let color2;
    if (color === '#080808') {
      color1 = '#1A1A1A';
      color2 = '#2B2B2B';
    }
    if (color === '#042357') {
      color1 = '#1D3865';
      color2 = '#344869';
    }
    if (color === '#022715') {
      color1 = '#4C6559';
      color2 = '#667B71';
    }
    if (color === '#333434') {
      color1 = '#505050';
      color2 = '#6F6F6F';
    }
    return { color1, color2 };
  };

  const pageStyles = useCallback(
    (props?: any) =>
      StyleSheet.create({
        body: {
          // flex: 1,
          // flexDirection: 'row',
        },
        title: {
          fontSize: 22,
          color: props?.color ?? '#000',
          fontFamily: 'OpenSans',
          fontWeight: 'bold',
          paddingBottom: 10,
          flexWrap: 'wrap',
        },
        author: {
          fontSize: 12,
          textAlign: 'center',
          marginBottom: 40,
        },
        subtitle: {
          fontSize: 18,
          margin: 12,
          fontFamily: 'Inter',
        },
        name: {
          fontSize: 32,
          color: props?.color ?? '#000',
          fontFamily: 'OpenSans',
          fontWeight: 'bold',
          textTransform: 'uppercase',
        },
        designation: {
          fontSize: 18,
          color: props?.color ? colors(props.color).color1 : '#1A1A1A',
          fontFamily: 'OpenSans',
          paddingTop: 6,
          fontWeight: 400,
        },
        country: {
          fontSize: 18,
          color: props?.color ? colors(props.color).color2 : '#2B2B2B',
          fontFamily: 'Inter',
          paddingTop: 6,
          fontWeight: 400,
        },
        text: {
          fontSize: 13,
          textAlign: 'left',
          lineHeight: 1.5,
          color: props?.color ? colors(props.color).color2 : '#2B2B2B',
          fontFamily: 'Inter',
        },
        textOrgrole: {
          fontSize: 13,
          textAlign: 'left',
          lineHeight: 1.5,
          color: 'black',
          fontFamily: 'Inter',
          fontWeight: 500,
        },
        textVolDuration: {
          fontSize: 13,
          textAlign: 'left',
          lineHeight: 1.5,
          color: '#2A2828',
          fontFamily: 'Inter',
          marginTop: 10,
          marginBottom: 3,
          // fontWeight: 'bold',
        },
        textInstitute: {
          fontSize: 13,
          textAlign: 'left',
          lineHeight: 1.5,
          color: '#4F4F4F',
          fontFamily: 'Inter',
        },
        linkTitle: {
          fontSize: 12,
          color: '#393838',
          fontFamily: 'Inter',
          textAlign: 'left',
          fontWeight: 'medium',
        },
        linkText: {
          fontSize: 12,
          textAlign: 'left',
          lineHeight: 1.5,
          color: '#150F0F',
          fontFamily: 'Inter',
        },
        contactText: {
          fontSize: 13,
          textAlign: 'left',
          lineHeight: 1,
          color: '#2A2828',
          fontFamily: 'Inter',
          paddingRight: -10,
          maxWidth: 155,
        },
        emailText: {
          fontSize: 13,
          textAlign: 'left',
          lineHeight: 1,
          color: '#2A2828',
          fontFamily: 'Inter',
          textDecoration: 'none',
          paddingRight: -10,
          maxWidth: 155,
        },
        descText: {
          fontSize: 10,
          textAlign: 'left',
          color: '#5F5F5F',
          fontFamily: 'Inter',
        },
        image: {
          marginVertical: 15,
          marginHorizontal: 100,
        },
        header: {
          fontSize: 12,
          marginBottom: 20,
          textAlign: 'center',
          color: 'grey',
        },
        footerBorder: {
          position: 'absolute',
          fontSize: 12,
          bottom: 0,
          left: 0,
          right: 0,
        },
        footerView: {
          height: 29,
          borderTopLeftRadius: 15,
          borderTopRightRadius: 15,
          backgroundColor: '#F00D0D',
        },
        staticContent: {
          position: 'absolute',
          fontSize: 12,
          bottom: 35,
          left: 100,
          right: 0,
          textAlign: 'center',
          color: '#241313',
        },
        headerBar: {
          // position: 'absolute',
          fontSize: 12,
          top: 15,
          left: 0,
          right: 0,
          height: 10,
          textAlign: 'center',
          color: 'grey',
        },
        colomn2: {
          backgroundColor: '#FFFFFF',
          flex: 2,
          // padding: 22,
          paddingHorizontal: 22,
        },
        colomn1: {
          backgroundColor: '#FFFFFF',
          flex: 1,
          paddingHorizontal: 22,
        },
        dashedBorder: {
          width: 2,
          height: '38.5%',
          borderRightWidth: 1,
          transform: 'scale(1, 4)',
          borderRightStyle: 'dashed',
          borderRightColor: '#AEAEAE',
          position: 'absolute',
          top: 0,
          left: 215,
        },
        durationBox: {
          backgroundColor: props?.color ?? '#042357',
          width: 118,
          height: 19,
          alignItems: 'center',
          justifyContent: 'center',
        },
        dateText: {
          color: '#FFF',
          fontSize: 10,
        },
        timeline: {
          color: '#5F5F5F',
          fontSize: 10,
          fontFamily: 'Inter',
        },
        exTitle: {
          fontSize: 15,
          textAlign: 'left',
          lineHeight: 1.5,
          color: props?.color ? colors(props.color).color1 : '#1A1A1A',
          fontFamily: 'OpenSans',
          paddingTop: 6,
          fontWeight: 'bold',
        },
        row: {
          flexDirection: 'row',
          alignItems: 'center',
          marginTop: 10,
        },
        tag: {
          backgroundColor: '#E5EAEC',
          minHeight: 22,
          borderRadius: 12,
          alignItems: 'center',
          justifyContent: 'center',
          paddingHorizontal: 8,
          padding: 5,
          marginRight: 10,
          marginBottom: 8,
        },
        headerContent: {
          // flex: 1,
          padding: 22,
          width: '100%',
          minHeight: 150,
        },
        redBox: {
          width: 73,
          height: 100,
          position: 'absolute',
          top: 0,
          right: 49,
          backgroundColor: '#F00D0D',
        },
      }),
    [],
  );

  const styles = useMemo(() => pageStyles({ color: selectedColor }), [selectedColor, pageStyles]);
  console.log('values', value);
  // group items by organization
  const groupedData = value.reduce((acc, item) => {
    const org = item.organization;
    if (org) {
      if (!acc[org]) {
        acc[org] = [];
      }
      acc[org].push(item);
    }
    return acc;
  }, {});

  const data = Object.entries(groupedData).map(([org, items]: any, index) => (
    <View key={index} style={{ paddingTop: 20 }}>
      {index === 0 && <Text style={styles.title}>Organizations</Text>}
      <Text style={styles.exTitle}>{org}</Text>
      {items &&
        items?.map((item, index) => {
          const from = moment(item.period.from);
          const fromStr = from.format('MMM YYYY');
          const to = moment(item.period.to);
          const toStr = item.period.to ? to.format('MMM YYYY') : 'Present';
          const duration = `${fromStr} - ${toStr}`;

          return (
            <>
              {item.position && <Text style={styles.textVolDuration}>{item.position}</Text>}
              <Text style={styles.textOrgrole}>{duration}</Text>
              {item?.description && <PdfHtml>{item?.description?.replace(/<[^>]*>/g, '')}</PdfHtml>}
            </>
          );
        })}
    </View>

    // <View style={{ paddingTop: 20 }}>
    //   <View key={index} wrap={false}>
    //     <View style={{ flexDirection: 'column', fontSize: 13, marginTop: 10 }}>
    //       <View>
    //         <Text style={{ color: '#7E7E7E' }}>{'\u2022'}</Text>
    //         {index === 0 && <Text style={styles.title}>Organizations</Text>}
    //         <Text style={styles.exTitle}>{org}</Text>
    //       </View>

    //       {items &&
    //         items?.map((item, index) => {
    //           const from = moment(item.period.from);
    //           const fromStr = from.format('MMM YYYY');
    //           const to = moment(item.period.to);
    //           const toStr = item.period.to ? to.format('MMM YYYY') : 'Present';
    //           const duration = `${fromStr} - ${toStr}`;

    //           return (
    //             <>
    //               {item.position && <Text style={styles.textOrgrole}>{item.position}</Text>}
    //               <Text style={styles.textVolDuration}>{duration}</Text>
    //               <View>
    //                 <Text>{item?.description?.replace(/<[^>]*>/g, '')}</Text>
    //               </View>
    //             </>
    //           );
    //         })}
    //     </View>
    //   </View>
    // </View>
  ));

  return <>{data}</>;
};
